import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  IChangeSignFieldPriorityEvent,
  IChangeSignFieldTypeEvent,
} from '@app/transaction-builder/model/sign-field-events.model';
import { IClientSignField } from '@app/transaction-builder/model/sign-field.model';
import { SignatureType } from 'ngx-mat-esign360';

@Component({
  selector: 'app-sign-field-list-item',
  templateUrl: './sign-field-list-item.component.html',
  styleUrls: ['./sign-field-list-item.component.scss'],
})
export class SignFieldListItemComponent implements OnInit {
  @Input() signField: IClientSignField;
  @Input() name: string;
  @Input() active: boolean;
  @Input() showSignFieldPriority: boolean;
  @Output() deleteSignField = new EventEmitter<IClientSignField>();
  @Output() changeSignFieldType = new EventEmitter<IChangeSignFieldTypeEvent>();
  @Output() changeSignFieldPriority = new EventEmitter<IChangeSignFieldPriorityEvent>();
  SignatureType = SignatureType;

  get signFieldPriority(): number {
    return this.signField?.priority ?? 1;
  }

  constructor() {}

  ngOnInit(): void {}

  onChangeSignFieldPriority(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    const priority = Number.parseInt(value, 10);

    this.changeSignFieldPriority.emit({
      signField: this.signField,
      priority,
    });
  }

  onChangeSignFieldType(signField: IClientSignField, type: SignatureType) {
    this.changeSignFieldType.emit({
      signField,
      type,
    });
  }
}
